import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { PagedUserResponse } from "src/app/shared/interfaces/iuser";

@Injectable({
  providedIn: "root",
})
export class UserDataServicesService {


  private mainURL = "genai-mic/auth/v3/system";

  constructor(private httpClient: HttpClient) { }

  // ---------------------------------------------------------
  // GET USER BY ID
  // ---------------------------------------------------------
  getUserById(id: string): Observable<any> {
    return this.httpClient.get(`${environment.apiUrl}${this.mainURL}/get/user/${id}`);
  }

  // ---------------------------------------------------------
  // PAGED USERS LIST
  // ---------------------------------------------------------
  getAllUsers(page: number, size: number): Observable<any> {
    return this.httpClient.get(
      `${environment.apiUrl}${this.mainURL}/list/users?page=${page}&size=${size}`
    );
  }

  getUsersForProject(projectId: string, page: number, size: number) {
    return this.httpClient.get<PagedUserResponse>(
      `${environment.apiUrl}${this.mainURL}/project/${projectId}/list/users?page=${page}&size=${size}`
    );
  }
  getUsersForProjectByRole(projectId: string, selectedRole: string, page: number, size: number) {
    return this.httpClient.get<PagedUserResponse>(
      `${environment.apiUrl}${this.mainURL}/project/${projectId}/role/${selectedRole}/list/users?page=${page}&size=${size}`
    );
  }



  // // ---------------------------------------------------------
  // // GET ROLES
  // // ---------------------------------------------------------
  // getUserRoles(): Observable<any> {
  //   return this.httpClient.get(`${environment.apiUrl}${this.mainURL}roles`);
  // }

  // ---------------------------------------------------------
  // CREATE USER
  // ---------------------------------------------------------
  createUser(projectId: string, payload: any): Observable<any> {
    return this.httpClient.post(`${environment.apiUrl}${this.mainURL}/project/${projectId}/users`, payload);
  }

  // ---------------------------------------------------------
  // UPDATE USER DETAILS
  // ---------------------------------------------------------
  changePassword(payload: any) {
    return this.httpClient.put(`${environment.apiUrl}admin/user`, payload);
  }


  // ---------------------------------------------------------
  // DELETE USER
  // ---------------------------------------------------------
  deleteUser(authUserId: string): Observable<any> {
    return this.httpClient.post(
      `${environment.apiUrl}${this.mainURL}/users/delete`,
      { authUserId }
    );
  }


  // ---------------------------------------------------------
  // UPDATE USER ROLE
  // ---------------------------------------------------------
  changeUserRole(projectId: string, payload: any): Observable<any> {
    return this.httpClient.put(
      `${environment.apiUrl}${this.mainURL}/project/${projectId}/user/change-role`,
      payload
    );
  }

  // ---------------------------------------------------------
  // SYSTEM: CHANGE USER PASSWORD
  // ---------------------------------------------------------
  changeSystemUserPassword(authUserId: string, payload: { newPassword: string }): Observable<any> {
    return this.httpClient.put(
      `${environment.apiUrl}${this.mainURL}/users/${authUserId}/change-password`,
      payload
    );
  }

  // ---------------------------------------------------------
  // FILTER USERS BY ROLE
  // ---------------------------------------------------------
  getUsersByRole(role: string): Observable<any> {
    return this.httpClient.get(
      `${environment.apiUrl}${this.mainURL}users/role/${role}`
    );
  }






}
